export default "__VITE_ASSET__XfhpSrY1__"